@if (show) {
  <div class="overlay" @fadeInOut (click)="show = false"></div>
  <div class="search-container" @fadeInOut>
    <form [formGroup]="form">
      <input #input class="search" [attr.placeholder]="searchPlaceHolder" type="text" formControlName="mainSearch" >
      @if (evaSearchResultLoading$ | async) {
        <mat-spinner [diameter]="20"></mat-spinner>
      }
      <div class="results-container" #results>
        @if (showMainSearchResults) {
          @for (action of (actions | fusejs:(mainSearchTerms | async):searchOptions); track action; let index = $index) {
            <a
              href=""
              (click)="selectMainSearchOpt($event, action.value)"
              (keyup.Enter)="selectMainSearchOpt($event, action.value)"
              >
              <span [innerHTML]="action.fuseJsHighlighted.title"></span>
            </a>
          }
        }
        @if (showEvaResults) {
          @for (result of evaSearchResults$ | async; track result; let index = $index) {
            <div @slideUpDown>
              <a
                href=""
                (click)="onResultItemClick($event, result)"
                (keyup.Enter)="onResultItemClick($event, result)"
                >
                @if (result.fuseJsHighlighted) {
                  <span [innerHTML]="result.fuseJsHighlighted.title"></span>
                }
                @if (!result.fuseJsHighlighted) {
                  <!-- TO:DO let all items go through fusejs pipe, to ensure code consistency and highlight results in relation to the query  -->
                  {{ result.title }}
                }
              </a>
            </div>
          }
          @if (form.get('mainSearch').value?.length > 0 && (evaSearchResults$ | async)?.length === 0) {
            <div class="empty">
              {{ (evaSearchResultLoading$ | async) ? 'Loading...' : 'No items'}}
            </div>
          }
        }
      </div>
    </form>
  </div>
}
